<template>
    <div class="drop-down" :class="{ open: isOpen }" :id="id">
        <button @click.prevent="$emit('click')">
            <img class="image" :src="image" v-if="image">
            <img :src="icon" v-if="icon" class="icon">
            <span v-if="label" :style="{'color': labelColor ? labelColor : '#000'}">{{label}}</span>
        </button>
        <div class="content" v-if="isOpen">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'custom-dropdown',
    props: {
        id: {
            type: String,
            description: 'Id attr'
        },
        label: {
            type: String,
            description: 'Drop down label',
        },
        labelColor: {
            type: String,
            description: 'Drop down label color',
        },
        image: {
            type: String,
            description: 'Image link'
        },
        icon: {
            type: String,
            description: 'Image link'
        },
        isOpen: {
            type: Boolean,
            default: false,
            description: 'Open dropdown status'
        }
    }
};
</script>

<style lang="scss">
    .drop-down {
        position: relative;
        &.open {
            button {
                &:after {
                    transform: rotate(180deg);
                }
            }
            .menu {
                display: inline-block;
            }
        }
        button {
            border: none;
            background: transparent;
            .image {
                width: 40px;
            }
        }
        .content {
            display: flex;
            flex-direction: column;
            padding: 14px 18px 18px;
            background: #FFFFFF;
            box-shadow: 0 4px 20px rgba(32, 0, 51, 0.1);
            border-radius: 20px;
            text-align: left;
            position: absolute;
            z-index: 1;
            right: 5px;
            top: 42px;
        }
    }
</style>

